// Components
import { Dropzone_s } from "components/import-export/import-styles"
import OverlaySpinner from 'components/spinner/overlay-spinner'
// Data
import importService from "data/import"
// Icons
import { CloseIcon } from "images/icons/general/"
import { UploadFileIcon } from "images/icons/tools/"
import React, { FC, useCallback, useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import Isvg from 'react-inlinesvg'
// Styles
import { Button_s } from "styles/app-styles"

const PDFImport: FC = () => {
  const [loading, updateLoading] = useState<boolean>(false);

  const onDrop = useCallback((acceptedFiles) => {
    importService.importPDF(acceptedFiles[0])
  }, [])
  const {getRootProps, getInputProps} = useDropzone({onDrop})

  useEffect(()=>{
    importService.stream().subscribe(obj => {
      updateLoading(obj['loading'])
    })
  }, [loading]);

  return (
    <div>
      <Dropzone_s {...getRootProps()}>
        <div>
          <span>Upload PDF</span>
          <a onClick={(e) => { e.stopPropagation(); importService.cancelImport() }}><Isvg src={CloseIcon} /></a>
        </div>
        <div>
          <input {...getInputProps()} />
          <Isvg src={UploadFileIcon} />
            <p>Drag and drop your PDF file or click here to upload</p>
          <Button_s primary>Browse and Upload</Button_s>
          <Button_s onClick={(e) => { e.stopPropagation(); importService.cancelImport() }}>Cancel</Button_s>
        </div>
      </Dropzone_s>
    { loading && <OverlaySpinner /> }
    </div>
  )
}

export default PDFImport
